import * as HLF from "html-living-framework";
import { Application } from "../../Application";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { AnimatedObstacle } from "../../GameObjects/Obstacles/AnimatedObstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class Pigeon extends AnimatedObstacle {
    private static readonly SPEED: number = -75;
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, 200);

    private _flapSfxID: any;

    constructor() {
        super(
            new HLF.SpriteAnimation(
                "pigeon-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00", 4, 2,
                12, true,
            ),
            Pigeon.SPEED,
            new BoxCollider(15, 130, -30, 30),
        );
        this.position.y = HLF.Random.floatBetweenPoint(Pigeon.Y_RANGE);
        this._collisionSfx = SFX.IMPACT_BIRD;

        Application.instance.audio.load(SFX.WINGFLAP, HLF.AudioCategory.SFX);
        const sfx: HLF.IAudioTrack = Application.instance.audio.getAudioTrack(SFX.WINGFLAP, HLF.AudioCategory.SFX)!;
        sfx.setLooped(true);
        sfx.setVolume(0.5);
        this._flapSfxID = (sfx as HLF.HowlerTrack).getSource().play();
    }

    public cleanup(): void {
        this.stopLoopSfx();
        super.cleanup();
    }

    public onCollision(pIsBalloonInvuln: boolean): void {
        super.onCollision(pIsBalloonInvuln);
        if (pIsBalloonInvuln) {
            this.stopLoopSfx();
            this.playDeflectAnim();
            this._anim.holdFrame(Pigeon.ANIM_KEY, 3);
        }
    }

    private stopLoopSfx(): void {
        const sfx: HLF.IAudioTrack = Application.instance.audio.getAudioTrack(
            SFX.WINGFLAP, HLF.AudioCategory.SFX,
        )!;
        (sfx as HLF.HowlerTrack).getSource().stop(this._flapSfxID);
    }
}
